/** Кнопки мыши */
export enum TirPmContextMenuMouseButtonEnum {
  /** Левая кнопка мыши */
  Left = 0,
  /** Колесико */
  Wheel = 1,
  /** Правая кнопка мыши */
  Right = 2,
}
